export default {
    pointerEvents: 'auto',
};
